<script lang="ts">
import { SwiperSlide } from 'swiper/vue';

import type { Swiper as SwiperType } from 'swiper';

export interface PhxsgSlideProps {
  tag?: string;
  swiperRef?: SwiperType;
  lazy?: boolean;
  zoom?: boolean;
  virtualIndex?: string | number;
}
</script>

<script setup lang="ts">
defineProps<PhxsgSlideProps>();
</script>

<template>
  <SwiperSlide v-bind="$props" class="phxsg-slider__item">
    <slot />
  </SwiperSlide>
</template>
